import { useState } from "react";
import { useStore } from "@/store/AppStore";
import { PageHeader } from "@/components/kit";
import { TaskBoard } from "@/components/TaskBoard";
import { TeamPerformance } from "@/components/TeamPerformance";
import { TeamManager } from "@/components/MasterForms";
import { Panel } from "@/components/kit";
import { nameMap } from "@/lib/selectors";
import { visibleTasks } from "@/lib/tasks";
import { PROFILES } from "@/data/mock";

export default function OwnerTeam() {
  const { state } = useStore();
  const { companyId: cid, name } = PROFILES.empresaria;
  const [selected, setSelected] = useState("all");
  const person = state.collaborators.find((c) => c.id === selected);
  const tasks = person ? visibleTasks(state, person) : state.tasks.filter((t) => t.companyId === cid);

  return (
    <div data-testid="owner-team-page">
      <PageHeader eyebrow="Equipe" title="Colaboradoras e tarefas" subtitle="Crie, atribua e acompanhe as tarefas de cada função. Clique em uma colaboradora para filtrar." />
      <TeamPerformance companyId={cid} selected={selected} onSelect={(id) => setSelected(selected === id ? "all" : id)} />
      <Panel title="Colaboradoras e acessos" subtitle="Cadastre a equipe e crie o login de cada colaboradora" className="mt-8" testId="owner-team-manager"><TeamManager companyId={cid} /></Panel>
      <div className="mt-8">
        {person && <button onClick={() => setSelected("all")} className="mb-3 text-xs font-semibold text-gold-dark hover:underline" data-testid="show-all-tasks">← Ver tarefas de toda a equipe</button>}
        <TaskBoard tasks={tasks} mode="owner" companyId={cid} actor={name} title={person ? `Tarefas de ${nameMap(state)[selected]}` : "Tarefas da equipe"} />
      </div>
    </div>
  );
}
